import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { 
  Button, 
  CircularProgress, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Chip
} from '@mui/material';
import { Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import {ProjectConfig} from 'Global';

interface Categoria {
  id: number;
  padre_id: number | null;
  titulo: string;
  date_type: string;
}

const OracionesLiturgicasList = () => {

  const [loading, setLoading] = useState(false); 
  const [categorias, setCategorias] = useState<Categoria[]>([]);

  /*=========================================================
  LOAD LIST            
  =========================================================*/
  useEffect(() => {
    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'oraciones_liturgicas_admin'
      }
    })
    .then((response) => {
      console.log("oraciones_liturgicas", response.data); 
      if (response.data.success) {
        setCategorias(response.data.categorias);
      }
      setLoading(true);
    })
    .catch((err) => {
      console.log(err);
      setLoading(true);
    });
  }, []);

  /*=========================================================
  GET DATE TYPE DISPLAY NAME         
  =========================================================*/
  const getDateTypeDisplayName = (dateType: string) => {
    const typeMap: { [key: string]: string } = {
      'oficio_lectura': 'Oficio de Lectura',
      'laudes': 'Laudes',
      'intermedias': 'Horas Intermedias',
      'visperas': 'Vísperas',
      'completas': 'Completas',
      'oraciones': 'Oraciones'
    };
    return typeMap[dateType] || dateType;
  };

  // Organizar categorías: padres con sus hijos
  const organizeCategorias = () => {
    const padres = categorias.filter(c => c.padre_id === null);
    const hijos = categorias.filter(c => c.padre_id !== null);
    
    return { padres, hijos };
  };

  const { padres, hijos } = organizeCategorias();

  return (
    <div id='OracionesLiturgicasList'>
      <div id="task_list_container" className="flex_container">
        <Box id='oraciones_liturgicas_list' title="Oraciones Litúrgicas" subtitle="Lista">
          {!loading && <div id='loader'><CircularProgress /></div>}
          
          <TableContainer>
            <Table stickyHeader aria-label="sticky table"> 
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Título</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Categorías padre */}
                {padres.map((categoria) => (
                  <>
                    <TableRow 
                      key={categoria.id} 
                      hover
                      style={{ backgroundColor: '#f5f5f5' }}
                    >
                      <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${categoria.id}` }}>
                        {categoria.id}
                      </TableCell>
                      <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${categoria.id}` }}>
                        <strong>{categoria.titulo}</strong>
                      </TableCell>
                      <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${categoria.id}` }}>
                        <Chip 
                          label={getDateTypeDisplayName(categoria.date_type)} 
                          variant="outlined" 
                          size="small" 
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          component={Link}
                          to={`/admin/oraciones-liturgicas/edit/${categoria.id}`}
                          variant="contained"
                          size="small"
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                      </TableCell>
                    </TableRow>
                    
                    {/* Subcategorías de este padre */}
                    {hijos.filter(h => h.padre_id === categoria.id).map((subcategoria) => (
                      <TableRow 
                        key={subcategoria.id} 
                        hover
                      >
                        <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${subcategoria.id}` }}>
                          {subcategoria.id}
                        </TableCell>
                        <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${subcategoria.id}` }} style={{ paddingLeft: 40 }}>
                          ↳ {subcategoria.titulo}
                        </TableCell>
                        <TableCell onClick={() => { window.location.href = `/admin/oraciones-liturgicas/edit/${subcategoria.id}` }}>
                          <Chip 
                            label={getDateTypeDisplayName(subcategoria.date_type)} 
                            variant="outlined" 
                            size="small" 
                          />
                        </TableCell>
                        <TableCell>
                          <Button
                            component={Link}
                            to={`/admin/oraciones-liturgicas/edit/${subcategoria.id}`}
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                          >
                            Editar
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
};

export default OracionesLiturgicasList;